// extracted by mini-css-extract-plugin
export var closeButton = "_mh-2";
export var closeButtonIcon = "_mh-3";
export var lightboxContent = "_mh-1";
export var lightboxOverlay = "_mh-0";